import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[capslock]',
    exportAs: 'capslock'
})
export class CapslockDirective {
    public isCapslock: boolean = false;
    private isCapsKnown: boolean = false;

    @HostListener('keypress', ['$event'])
    public onKeyPress(event: KeyboardEvent) {
        const { keyCode, shiftKey } = event;
        const isUp = (keyCode >= 65 && keyCode <= 90);
        const isLow = (keyCode >= 97 && keyCode <= 122);

        if ((isUp && !shiftKey) || (isLow && shiftKey)) {
            this.isCapslock = true;
        } else {
            this.isCapslock = false;
        }

        if (!this.isCapsKnown && (isLow || isUp)) {
            this.isCapsKnown = true;
        }
    }

    @HostListener('document:keydown', ['$event'])
    public onKeyDown(event) {
        const { keyCode } = event;

        if (this.isCapsKnown && keyCode === 20) {
            this.isCapslock = !this.isCapslock;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/capslock.directive.ts